/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: uas-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($){
    var $selectionWrapper = $('.extension-uas__selection-contenu');
    if($selectionWrapper.length > 0){
        $selectionWrapper.each(function(index){
            var $currentWrapper = $(this),
                idName = $currentWrapper.attr('id').replace('selection-', '');

            // Création d'une checkbox pour les gouverner toutes
            var $master = $('<p class="extension-uas__selection-contenu_master"><input type="checkbox" id="' + idName +'" name="' + idName +'" class="extension-uas__selection-contenu_master-checkbox"><label for="' + idName +'">Tout cocher</label></p>');
            $master.appendTo($currentWrapper);

            var $masterCheckbox = $master.find('.extension-uas__selection-contenu_master-checkbox');
            $masterCheckbox.change(function(){
                var $checkboxes = $currentWrapper.find('input[type="checkbox"]:not(.extension-uas__selection-contenu_master-checkbox)');
                $checkboxes.each(function(index){
                    $(this).prop('checked', $masterCheckbox.prop('checked'));
                });
            });
        });
    }

    /**
     * Déclaration d'un tri spécifique pour les poids de fichier nnn (bytes|[KMGT]B) / -
     */
    $.extend($.fn.dataTableExt.oSort, {
        'filesize-pre': function (a) {
            var b = Number.NaN;
            if (a !== null) {
                b = parseInt(a, 10);
                var regex = /(?:[0-9]+ *)(.B)?/gi;
                var match = regex.exec(a.toUpperCase());
                var factor = match[1];
                switch (factor) {
                    case 'KB':
                        b *= 1024;
                        break;
                    case 'MB':
                        b *= 1024*1024;
                        break;
                    case 'GB':
                        b *= 1024*1024*1024;
                        break;
                    case 'TB':
                        b *= 1024*1024*1024*1024;
                        break;
                    default:
                    //nothing
                }
            }
            return b;
        },

        'filesize-asc': function (x, y) {
            var result = 0;
            if (isNaN(x) && isNaN(y)) {
                result = 0;
            } else if (x < y || isNaN(y)) {
                result = -1;
            } else if (x > y || isNaN(x)) {
                result = 1;
            }
            return result;
        },

        'filesize-desc': function (x, y) {
            var result = 0;
            if (isNaN(x) && isNaN(y)) {
                result = 0;
            } else if (x < y || isNaN(x)) {
                result = 1;
            } else if (x > y || isNaN(y)) {
                result = -1;
            }
            return result;
        }
    });

    var dataTableArchive = $('.dataTableArchive');
    dataTableArchive.dataTable({
        'aaSorting': [[1, 'desc']],
        'aoColumns': [
            null,
            {'sType': 'date-jjmmaaaa-hhmm'},
            {'sType': 'filesize'},
            {'bSortable': false, 'bSearchable': false}
        ]
    });
})(jQuery.noConflict());